import React from "react"
import {PlatformType} from "../utils/constants";

import Dealer from "../pages/dealer/index";
import DealerDetail from "../pages/dealer-detail";
import Company from "../pages/platform-pages/admin/company";
import HospitalEdit from "../pages/platform-pages/admin/hospital-edit";
import Hospital from "../pages/platform-pages/admin/hospital";
import PlacingInstrumentsEdit from "../pages/platform-pages/admin/placing-instruments-edit";
import PlacingInstruments from "../pages/platform-pages/admin/placing-instruments";
import Index from "../pages/platform-pages/admin/index";
import ExpressFreight from "../pages/platform-pages/admin/express-freight";
import ExpressFreightEdit from "../pages/platform-pages/admin/express-freight-edit";
import {withRouter} from "react-router";
import Bulletin from "../pages/bulletin";
import FinanceReceipt from "../pages/platform-pages/admin/finance-receipt";
import FinanceRefund from "../pages/platform-pages/admin/finance-refund";
import FinanceWriteOff from "../pages/platform-pages/admin/finance-write-off";
import Scheduled from "../pages/scheduled";
import FinanceReceiptDetail from "../pages/platform-pages/admin/finance-receipt-detail";
import FinanceWriteOffDetail from "../pages/platform-pages/admin/finance-write-off-detail";
import ProductQty from "../pages/product-qty";
import ContractPriceList from "../pages/platform-pages/admin/contract-price-list";
import ContractGiveawayRemain from "../pages/platform-pages/admin/contract-giveaway-remain/ContractGiveawayRemain";
import SysBaseData from "../pages/platform-pages/admin/sys-base-data";
import ApiConfig from "../pages/api-config";
import SysPosition from "../pages/platform-pages/admin/sys-position";
import Qualification from "../pages/qualification";
import QualificationReport from "../pages/qualification-report";
import FinanceRefundDetail from "../pages/platform-pages/admin/finance-refund-detail";
import MeinianOrderDetail from "../pages/platform-pages/admin/meinian-order-detail";
import MeinianOrder from "../pages/platform-pages/admin/meinian-order";
import ExternalDealer from "../pages/platform-pages/admin/external-dealer";
import YunyigouOrderDetail from "../pages/platform-pages/admin/yunyigou-order-detail";
import YunyigouOrder from "../pages/platform-pages/admin/yunyigou-order";
import SysDepartment from "../pages/platform-pages/admin/sys-department";
import DealerCreditStatistics from "../pages/platform-pages/admin/dealer-credit-statistics";
import ExternalSystem from "../pages/external-system";
import MeinianNewOrderDetail from "../pages/platform-pages/admin/meinian-new-order-detail";
import MeinianNewOrder from "../pages/platform-pages/admin/meinian-new-order";
import warehouseVoucher from "../pages/platform-pages/admin/warehouse-voucher";
import ExternalExpress from "../pages/platform-pages/admin/external-express";
import PreDealer from "../pages/pre-dealer";
import PreDealerDetail from "../pages/pre-dealer-detail";

const SysUser = React.lazy(() => import('../pages/platform-pages/admin/sys-user'))
const SysResource = React.lazy(() => import('../pages/platform-pages/admin/sys-resource'))
const SysRole = React.lazy(() => import('../pages/platform-pages/admin/sys-role'))
const SysSite = React.lazy(() => import('../pages/platform-pages/admin/sys-site/index'))
const SysDict = React.lazy(() => import('../pages/platform-pages/admin/sys-dict'))


const route: Route = {
    '/sys/user': {
        component: SysUser
    },
    '/sys/resource': {
        component: SysResource
    },
    '/sys/role': {
        component: SysRole,
    },
    '/sys/company': {
        component: Company,
    },
    '/sys/bulletin': {
        component: Bulletin,
    },
    '/sys/scheduled': {
        component: Scheduled,
    },
    '/sys/position/0': {
        render: () => (<SysPosition type={0}/>)
    },
    '/sys/position/1': {
        render: () => (<SysPosition type={1}/>)
    },
    '/sys/department': {
        component: SysDepartment
    },
    '/dealer/user': {
        render: () => (<SysUser platform={PlatformType.Dealer}/>)
    },
    '/sys/baseData': {
        component: SysBaseData
    },
    '/dealer/resource': {
        render: () => (<SysResource platform={PlatformType.Dealer}/>)
    },
    '/dealer/role': {
        render: () => (<SysRole platform={PlatformType.Dealer}/>)
    },
    '/sys/site': {
        component: SysSite
    },
    '/sys/dict': {
        component: SysDict
    },
    '/customer/hospital/add/': {
        component: HospitalEdit
    },
    '/customer/hospital/detail/:id?': {
        component: HospitalEdit
    },
    '/customer/hospital/': {
        component: Hospital
    },
    '/product/placingInstruments/addPage/': {
        component: PlacingInstrumentsEdit
    },
    '/product/placingInstruments/detailPage/:id?': {
        component: PlacingInstrumentsEdit
    },
    '/product/placingInstruments/': {
        component: PlacingInstruments
    },
    '/product/qty/': {
        component: ProductQty
    },
    '/product/qualification/': {
        component: Qualification
    },
    '/product/qualificationReport/': {
        component: QualificationReport
    },
    '/customer/dealer/detail/:id?': {
        component: DealerDetail
    },
    '/customer/dealer/version/:id': {
        component: DealerDetail
    },
    '/customer/dealer/': {
        component: Dealer
    },
    '/customer/preDealer/detail/:id': {
        component: PreDealerDetail
    },
    '/customer/preDealer/': {
        component: PreDealer
    },
    '/contract/priceList/': {
        component: ContractPriceList
    },
    '/contract/expressFreight/detailPage/:id': {
        component: ExpressFreightEdit
    },
    '/contract/expressFreight/': {
        component: ExpressFreight
    },
    '/contract/giveawayRemain/': {
        component: ContractGiveawayRemain
    },
    '/contract/dealerCreditStatistics': {
        component: DealerCreditStatistics
    },
    '/finance/receipt/detail/:id/receiptWriteOffPage/:id': {
        component: FinanceWriteOffDetail
    },
    '/finance/receipt/detail/:id': {
        component: FinanceReceiptDetail
    },
    '/finance/receipt/': {
        component: FinanceReceipt
    },
    '/finance/refund/detail/:id': {
        component: FinanceRefundDetail
    },
    '/finance/refund/': {
        component: FinanceRefund
    },
    '/finance/writeOff/detail/:writeOffId': {
        component: FinanceWriteOffDetail
    },
    '/finance/writeOff/': {
        component: FinanceWriteOff
    },
    '/api/externalDealer': {
        component: ExternalDealer
    },
    '/api/external/express': {
        component: ExternalExpress
    },
    '/api/meinian/new/detail/:id': {
        component: withRouter(MeinianNewOrderDetail)
    },
    '/api/meinian/new': {
        component: MeinianNewOrder
    },
    '/api/meinian/detail/:id': {
        component: withRouter(MeinianOrderDetail)
    },
    '/api/meinian': {
        component: MeinianOrder
    },
    '/api/yunyigou/detail/:id': {
        component: withRouter(YunyigouOrderDetail)
    },
    '/api/yunyigou': {
        component: YunyigouOrder
    },
    '/api/config': {
        component: ApiConfig
    },
    '/api/external': {
        component: ExternalSystem
    },
    '/api/warehouse/voucher': {
        component: warehouseVoucher
    },
    '/index': {
        component: Index
    },
}
export default route;
